import React from "react";
import styles from "./ProductDivider.module.less";

const ProductDivider = () => <div className={styles.productDivider} />;

export default ProductDivider;
